import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { FHAhomeInspection, getexternaldocuments } from "../../../../api/transaction"
import Esign from "../Esign"
import useToggle from "../../../../hooks/toggle"
import { useReactToPrint } from 'react-to-print';
import { selecteddocumentesign } from "../ReviewDocs"
import { CSpinner } from "@coreui/react"
const FHAhomeinspection = ()=>{
    const {id,user} : any = useParams()
    const componentRef = useRef();
    const [homeinspection,setHomeinspection] = useState({
        offer_id :Number(id),
        home_inspcetion_chk1 :false,
        home_inspcetion_chk2 :false,
        signature1 :null,
        signature1_date :null,
        signature2 :null,
        signature2_date :null
    })

    const [canvasmodal, setCanvasModal] = useToggle(false);
    const [htmlContent, setHtmlContent] = useState("");
    const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
        offerid : "",
      document_name: "",
      image_base64: "",
      sign_role: 1
      })

      const printf = () => {
        handlePrint()
  };
  const [loader,setloading] = useState(false)
   // @ts-ignore
   const val = useSelector((state) => state?.new?.signset)
   

   useEffect(()=>{
    if(val){
        if(user == "seller"){
          setHomeinspection({ ...homeinspection, signature2: val })
        }
        if(user == "client"){
          setHomeinspection({ ...homeinspection, signature1: val })
        }
    }
    },[val])

 const send = async()=>{
  setloading(true)
   if(user==="seller"){

    if(homeinspection?.signature2){
        
        let res = await FHAhomeInspection(homeinspection)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
    }
   
   } else if(user==="client"){
  
    if(homeinspection?.signature1){
        let res = await FHAhomeInspection(homeinspection)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
    }
   }
   setloading(false)
}   

const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});
useEffect(()=>{
    (async function(){
  
      const res =await getexternaldocuments(id,"fhahomeinspection") 
      setHomeinspection({...homeinspection,
        home_inspcetion_chk1 :res?.data?.home_inspcetion_chk1,
        home_inspcetion_chk2 :res?.data?.home_inspcetion_chk2,
        signature1 :res?.data?.signature1,
        signature1_date :res?.data?.signature1_date,
        signature2 :res?.data?.signature2,
        signature2_date :res?.data?.signature2_date
      })
    })()
  },[])


    return(
        <>
        <table ref={componentRef}
  style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 20 }}
>
  <tbody>
    <tr>
      <td>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ fontSize: 12, fontWeight: 500 }}>
                        U.S. Department of Housing and Urban Development (HUD)
                        <br />
                        Federal Housing Administration (FHA)
                      </td>
                      <td
                        style={{
                          fontSize: 12,
                          fontWeight: 500,
                          float: "right"
                        }}
                      >
                        OMB Approval No: 2502-0538 (exp. 07/31/2009)
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ width: "30%" }}>
                <img
                  style={{ width: 250 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                />
              </td>
              <td style={{ width: "40%", textAlign: "center" }}>
                <span style={{ fontSize: 20, fontWeight: 600 }}>
                  ADDENDUM TO PURCHASE AGREEMENT
                </span>
                <br />
                <span style={{ fontSize: 15 }}>
                  FHA Amendatory Clause and Real Estate Certification{" "}
                </span>
                <br />
                <span style={{ fontSize: 11 }}>
                  This addendum is legally binding. If not understood, seek
                  legal advice.)
                </span>
              </td>
              <td
                style={{
                  width: "30%",
                  float: "right",
                  verticalAlign: "middle"
                }}
              >
                <img
                  style={{ width: 30 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                  alt=""
                />
                <img
                  style={{ width: 50 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ textAlign: "center", paddingTop: 10 }}>
        <span style={{ fontSize: 30, fontWeight: 500 }}>
          For Your Protection: Get a Home Inspection
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 10 }}>
        <span style={{ fontWeight: 500 }}>
          Why a Buyer Needs a Home Inspection
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 10 }}>
        <span>
          A home inspection gives the buyer more detailed information about the
          overall condition of the home prior to purchase. In a home inspection,
          a qualified inspector takes an in-depth, unbiased look at your
          potential new home to:
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px 0px 30px" }}>
        <span>
          
          - Evaluate the physical condition: structure,
          construction, and mechanical systems;
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px 0px 30px" }}>
        <span>
          - Identify items that need to be repaired or
          replaced; and
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px 0px 30px" }}>
        <span>
        - Estimate the remaining useful life of the
          major systems, equipment, structure, and finishes.
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 10 }}>
        <span style={{ fontWeight: 600 }}>
          Appraisals are Different from Home Inspections
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          An appraisal is different from a home inspection. Appraisals are for
          lenders; home inspections are for buyers. An appraisal is required to:
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px 0px 30px" }}>
        <span>
         -
          Estimate the market value of a house;
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px 0px 30px" }}>
        <span>
        - Make sure that the house meets FHA minimum
          property standards/requirements; and
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px 0px 30px" }}>
        <span>
          - Make sure that the property is marketable.
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 10 }}>
        <span style={{ fontWeight: 600 }}>
          FHA Does Not Guarantee the Value or Condition of your Potential New
          Home
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          If you find problems with your new home after closing, FHA can not
          give or lend you money for repairs, and FHA can not buy the home back
          from you. That is why it is so important for you, the buyer, to get an
          independent home inspection. Ask a qualified home inspector to inspect
          your potential new home and give you the information you need to make
          a wise decision
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 10 }}>
        <span style={{ fontWeight: 600 }}>Radon Gas Testing</span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          The United States Environmental Protection Agency and the Surgeon
          General of the United States have recommended that all houses should
          be tested for radon. For more information on radon testing, call the
          toll-free National Radon Information Line at 1-800-SOS-Radon or
          1-800-767-7236. As with a home inspection, if you decide to test for
          radon, you may do so before signing your contract, or you may do so
          after signing the contract as long as your contract states the sale of
          the home depends on your satisfaction with the results of the radon
          test.
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span style={{ fontWeight: 600 }}>Be an Informed Buyer</span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          It is your responsibility to be an informed buyer. Be sure that what
          you buy is satisfactory in every respect. You have the right to
          carefully examine your potential new home with a qualified home
          inspector. You may arrange to do so before signing your contract, or
          may do so after signing the contract as long as your contract states
          that the sale of the home depends on the inspection.
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ borderBottom: "2px solid black" }}></td>
    </tr>
    <tr>
      <td>
        <span>
          I/we understand the importance of getting an independent home
          inspection. I/we have considered this before signing a contract with
          the seller for a home. Furthermore, I/we have carefully read this
          notice and fully understand that FHA will not perform a home
          inspection nor guarantee the price or condition of the property.
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px 0px 30px" }}>
        <span>
          <input type="checkbox" />
          I/We choose to have a home inspection performed.
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "10px 0px 0px 30px" }}>
        <span>
          <input type="checkbox" />
          I/We choose not to have a home inspection performed
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 10 }}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <span>
                  <img
                     src={user === "client" ? (val || homeinspection?.signature1): homeinspection?.signature1}
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid black",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <span>Signature</span>
                      </td>
                      <td>
                        <input type="date" value={homeinspection?.signature1_date ? homeinspection?.signature1_date  : (user === "client" && val || homeinspection?.signature1) ? new Date().toISOString().split('T')[0] : ""}
                         onChange={(e)=>setHomeinspection({...homeinspection,signature1_date:e.target.value})}/>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <span>
                  <img
                    src={user === "seller" ? (val || homeinspection?.signature2): homeinspection?.signature2}
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid black",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <span> Signature</span>
                      </td>
                      <td>
                      <input type="date" value={homeinspection?.signature2_date ? homeinspection?.signature2_date  : (user === "seller" && val || homeinspection?.signature2) ? new Date().toISOString().split('T')[0] : ""}
                       onChange={(e)=>setHomeinspection({...homeinspection,signature2_date:e.target.value})}/>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 10 }}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ fontSize: 12, fontWeight: 600 }}>
                        Ver. 20080514
                      </td>
                      <td
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          float: "right"
                        }}
                      >
                        HUD-92564-CN (6/06)
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 10 }}>
        <span>
          other provision:Earnestdesposite to be delivered with in(5) business
          days.
        </span>
      </td>
    </tr>
  </tbody>
</table>
{
  user !== "agent" && 
  <>
<React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>

  <Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
  </>
}

        </>
    )
}

export default FHAhomeinspection